<script setup lang="ts">
import type { FormKitFrameworkContext } from '@formkit/core'
import { Select, type SelectProps } from '../primevue/select'

const props = defineProps<{
  context: FormKitFrameworkContext & SelectProps
}>()

async function onUpdated(value?: string | undefined) {
  await props.context.node.input(value)
}
</script>

<template>
  <Select
    v-bind="{ ...context.attrs, disabled: context.attrs.readonly || context.attrs.disabled }"
    :options="context.options"
    :load-options="context.loadOptions"
    :ensure-selected="context.ensureSelected"
    :model-value="context.value"
    @update:model-value="onUpdated"
  />
</template>
